import React from "react";

import { SvgIcon } from "@mui/material/";

const CheckCircle = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 96 960 960">
      <path d="m427.462 712.308 233.846-232.846L620 438.154 427.462 629.692l-87-86L299.154 585l128.308 127.308ZM480.134 952q-77.313 0-145.89-29.359-68.577-29.36-120.025-80.762-51.447-51.402-80.833-119.917Q104 653.446 104 576.134q0-78.569 29.418-146.871 29.419-68.303 80.922-119.917 51.503-51.614 119.916-80.48Q402.67 200 479.866 200q78.559 0 146.853 28.839 68.294 28.84 119.922 80.422 51.627 51.582 80.493 119.841Q856 497.361 856 575.95q0 77.589-28.839 145.826-28.84 68.237-80.408 119.786-51.569 51.548-119.81 80.993Q558.702 952 480.134 952Z" />
    </SvgIcon>
  );
};

export default CheckCircle;
